// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconArrowRightLine = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M46.8275 30.6366C47.627 31.4946 47.627 32.5051 46.8275 33.3633C46.028 34.2214 33.1238 48.3662 32.2615 49.2917C31.3992 50.2173 30.2785 50.2371 29.384 49.3427C28.4894 48.4481 27.5518 47.5105 26.6573 46.616C25.7628 45.7214 25.7826 44.6008 26.7082 43.7385C27.2321 43.2502 32.0238 38.8738 36.084 35.1672C27.4392 35.4264 9.03766 35.9771 8.06909 35.9991C6.80096 36.0281 6 35.245 6 33.9766V30.0233C6 28.7549 6.80096 27.9719 8.06909 28.0007C9.03766 28.0227 27.4391 28.5735 36.0839 28.8325C32.0237 25.126 27.2321 20.7496 26.7082 20.2615C25.7827 19.3992 25.7628 18.2786 26.6573 17.384C27.5519 16.4895 28.4895 15.5518 29.384 14.6572C30.2785 13.7628 31.3992 13.7826 32.2615 14.7083C33.1238 15.6338 46.028 29.7786 46.8275 30.6366ZM54 8H52C50.7659 8 50 8.76587 50 10V54C50 55.2341 50.7659 56 52 56H54C55.2341 56 56 55.2341 56 54V10C56 8.76587 55.2341 8 54 8Z" />
    </svg>
  );
};
